import { ChangeDetectionStrategy, Component, OnInit, ModelSignal, model, WritableSignal, signal } from '@angular/core';
import { Router } from '@angular/router';
import { IncidentsService } from 'src/app/api/incidents.service';


interface ReportTypes {
  name: string,
  targetRoute: string
}

export type EntryMethods = "here" | "link"

@Component({
    selector: 'app-pick-report-type',
    templateUrl: './pick-report-type.component.html',
    styleUrls: ['./pick-report-type.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PickReportTypeComponent implements OnInit {

  reportTypes: ReportTypes[] = [
    {
      name: "the affected person",
      targetRoute: "staff-or-participant",
    },
    {
      name: "the Leader/Supervisor the incident was reported to",
      targetRoute: "supervisor"
    },
    {
      name: "a witness of the incident",
      targetRoute: "witness"
    }
  ]

  selectedReportType: ModelSignal<ReportTypes> = model(this.reportTypes[0]);

  selectedEntryMethod: ModelSignal<EntryMethods> = model<EntryMethods>("here");
  name = model("");
  email = model("");
  incidentDate = model(new Date());

  requestLink = signal("");
  linkCopied = signal(false);



  constructor(
    private router: Router,
    private incidentService: IncidentsService
  ) { }

  ngOnInit(): void {
  }

  reportTypeSelected() {
    if (this.selectedEntryMethod() === "here" ) {
      this.router.navigate([
        'incidents',
        'incident-reports',
        this.selectedReportType().targetRoute,
        'create',
      ]);

    }
    else {
      if (this.name().trim() !== "") {
        this.incidentService.getIncidentReportLink(this.name(), this.email(), this.incidentDate(), this.selectedReportType().targetRoute).subscribe(response => {
          this.requestLink.set(response.link);
        })
      //generate link
    }
  }

}

onLinkCopied() {
  this.linkCopied.set(true);
}

}
